import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DirectivesModule } from 'src/lib/directives/directives.module';
import { PipesModule } from 'src/lib/pipes/pipes.module';
import { LoadingComponent } from '../components/loading/loading.component';

// TODO: 더이상 사용하지 않는 모듈 삭제 검토
// TODO: 잘 사용되지 않는 모듈 삭제 검토
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DirectivesModule,
    PipesModule,
    LoadingComponent,
  ],
  exports: [
    CommonModule,
    RouterModule,
    LoadingComponent,
    DirectivesModule,
    PipesModule,
  ],
})
export class SharedModule {}
